import React from "react";
import CommonBanner from "../component/Common/CommonBanner";
import FlightConfirmationArea from "component/FlightConfirmation";
import { useTranslation } from "react-i18next";
const FlightConfirmation = () => {
    const { t } = useTranslation();
    return (
        <>
            <CommonBanner
                heading={t("flightEticket")}
                pagination="Booking submission"
            />
            <FlightConfirmationArea />
        </>
    );
};

export default FlightConfirmation;
